export default __webpack_public_path__ + "static/media/event-web.33cf77cf.svg";